module.exports = __webpack_public_path__ + "static/img/13.01d4cb0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/3/zh/13.png
// module id = iOeL
// module chunks = 0